<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('shipments.modes', 2)"
    class="shipment-mode-filter w-2"
    optional
  >
    <ModeMultiSelect :id="inputId" v-model="internalModes" />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, Ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';
import { Mode } from '@rygen/rygen-ui/model';

import { ShipmentSearchCriteria } from '@/model';

import ModeMultiSelect from '@/components/shipment/ModeMultiSelect.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipmentSearchCriteria,
    default: () => new ShipmentSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ShipmentSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipmentSearchCriteria>) =>
    new ShipmentSearchCriteria(opts),
});

const internalModes: Ref<Mode[]> = computed({
  get() {
    return internalValue.value.modes as Mode[];
  },
  set(newVal: Mode[]) {
    internalValue.value.modes = newVal as string[];
  },
});
</script>
